import { render, staticRenderFns } from "./LargeButtonWithIcon.vue?vue&type=template&id=4a620e73&scoped=true&"
import script from "./LargeButtonWithIcon.vue?vue&type=script&lang=js&"
export * from "./LargeButtonWithIcon.vue?vue&type=script&lang=js&"
import style0 from "./LargeButtonWithIcon.vue?vue&type=style&index=0&id=4a620e73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a620e73",
  null
  
)

export default component.exports